import axios from 'axios'
import { ApiConfig } from '../../../config/api'
import { Asn, ISearchASN } from '../../../interfaces/Asn/Asn'
import { GenericOrderBy } from '../../../components/_EOS/Table'

export const getAsn = (
  pageIndex = 0,
  pageSize = 5,
  filters: ISearchASN,
  orderBy: GenericOrderBy<Asn>,
  supplierId?: number
) => {
  const url = new URL(ApiConfig.AsnApi)

  url.searchParams.set('pageIndex', pageIndex.toString())
  url.searchParams.set('pageSize', pageSize.toString())

  if (orderBy) {
    url.searchParams.set(
      'sorters',
      JSON.stringify({ datafield: orderBy.field, sortOrder: orderBy.direction })
    )
  }

  if (supplierId) {
    url.searchParams.set('supplierId', supplierId.toString())
  }

  url.searchParams.set(filters.searchField, filters.searchValue)

  return axios.get(url.toString())
}

export const deleteAsn = (asnId: number) => {
  const url = new URL(`${ApiConfig.AsnApi}/SoftDelete`)

  url.searchParams.set('asnId', asnId.toString())

  return axios.delete(url.toString())
}

export const getAsnState = (asnId: number) => {
  const url = new URL(`${ApiConfig.AsnApi}/${asnId}`)
  return axios.get(url.toString())
}
